import { useStore } from 'effector-react'
import { payModel } from '~/entities/Balance'
import { CURRENCY } from '~/shared/config/constants'
import { Wrapper, Title, CommissionSkeleton } from './styled'

type CommissionProps = {
  isLoading: boolean
}

export function Commission({ isLoading }: CommissionProps) {
  const commission = useStore(payModel.$payCommission)

  if (!commission?.commissionAmount && !isLoading) {
    return <Title>Размер комиссии будет уточнен после ввода суммы</Title>
  }

  return (
    <Wrapper>
      <div>Комиссия</div> —{' '}
      {isLoading ? (
        <CommissionSkeleton />
      ) : (
        <span style={{ marginTop: '2px' }}>
          {commission?.commissionAmount || 0} {CURRENCY}
        </span>
      )}
    </Wrapper>
  )
}
